import { useState, useEffect } from 'react'

import Modal from 'shared/components/Modal'
import { isMobile } from 'shared/responsive-helpers'

import { RatingModalContent } from './RatingModalContent'
import { ThankYouModalContent } from './ThankYouModalContent'

import styles from './styles.module.scss'

const NpsModal = ({ surveyData, onModalClose, onSubmit, onSkip, showThankYouModal, pending }) => {
    const ratingArray = Array.from({ length: 11 }, (_, index) => index)
    const [rating, setRating] = useState(null)
    const [ratingContentVisible, setRatingContentVisible] = useState(true)
    const [ratingFeedbackText, setRatingFeedbackText] = useState(null)

    const modalHeaderLabel = ratingContentVisible ? surveyData.titleText : surveyData.thankYouTitle

    const modalWrapClassname = ratingContentVisible ? styles.ratingContentModalWrap : styles.thankYouModalWrap

    const onSubmitDisabled = rating === null || pending

    useEffect(() => {
        showThankYouModal && setRatingContentVisible(false)
    }, [showThankYouModal])

    return (
        <Modal header={modalHeaderLabel} className={modalWrapClassname} size={isMobile() ? 'small' : 'large'}>
            {ratingContentVisible ? (
                <RatingModalContent
                    ratingText={surveyData.ratingText}
                    ratingExplanation={surveyData.ratingExplanation}
                    questionText={surveyData.questionText}
                    questionHint={surveyData.questionHint}
                    ratingFeedbackText={ratingFeedbackText}
                    setRatingFeedbackText={setRatingFeedbackText}
                    textFeedbackRequired={surveyData.textResponseRequired}
                    ratingArray={ratingArray}
                    setRating={setRating}
                    rating={rating}
                    onSkip={onSkip}
                    onSubmit={onSubmit}
                    onSubmitDisabled={onSubmitDisabled}
                    pending={pending}
                />
            ) : (
                <ThankYouModalContent thankYouBody={surveyData.thankYouBody} onClose={onModalClose} />
            )}
        </Modal>
    )
}

export default NpsModal
